import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { SentenceModule } from '@app/_shared/pipes/sentence/sentence.module';
import { BrokersComponent } from './brokers.component';
import { BrokersRoutingModule } from './brokers-routing.module';
import { AddBrokerModule } from '@app/_shared/modules/add-broker/add-broker.module';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox'



@NgModule({
  declarations: [
    BrokersComponent
  ],
  imports: [
    CommonModule,
    MatListModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatFormFieldModule,
    MatSelectModule,
    MatTooltipModule,
    MatCheckboxModule,
    SentenceModule,
    AddBrokerModule,
    BrokersRoutingModule
  ],
  exports: [
    BrokersComponent
  ]
})
export class BrokersModule { }
